import apiClient from "../helpers/apiClient";
import { ManageMemberModel } from "../pages/manageMembers/models/ManageMemberModel";

// Admin filters (WP-C): plan title + active/inactive membership status. Sent as `plan` /
// `is_active` query params (see nobilis-social PR #39). Absent → not filtered.
export interface ManageMemberFilters {
    plan?: string;
    isActive?: string; // 'active' | 'inactive' | '' (UI value)
}

export const getSearchableManageMembers = async (search: string, activeTab: string, limit:number = 1, offset:number = 0, filters: ManageMemberFilters = {}): Promise<ManageMemberModel> => {

    const segmentMap: Record<string, string> = {
        'new-members': 'new_members',
        'create-profile': 'create_profile',
    }

    const segment = segmentMap[activeTab] || ''
    const params = new URLSearchParams()
    if (search) params.append('search', search)
    if (segment) params.append('segment', segment)
    if (filters.plan) params.append('plan', filters.plan)
    if (filters.isActive === 'active') params.append('is_active', 'true')
    if (filters.isActive === 'inactive') params.append('is_active', 'false')
    params.append('limit',`${limit}`)
    params.append('offset',`${offset}`)

    const queryString = params.toString()
    const url = `/admin/members/${queryString ? `?${queryString}` : ''}`

    const response = await apiClient.get(url)
    return response.data
};